import TagManager from 'react-gtm-module'
import { gtmId } from './gtm/index.erb'

const tagManager = (): void => {
   
  // @ts-ignore
  if (gtmId !== '') {
    const path = window.location.pathname

    if (path.startsWith('/client')) {
      TagManager.initialize({
        gtmId,
        dataLayerName: 'ClientDataLayer'
      })
    } else {
      TagManager.initialize({ gtmId })
    }
  }
}

export default tagManager
